<vehicle-type-switch-component [selectedValue]="selectedVehicleType" (selectedValueChange)="selectedVehicleTypeValueChange($event)"></vehicle-type-switch-component>
<div class="row" id="main-content">
  <div class="col-xl-12 col-sm-12 h-100">
    <div class="row h-100">
      <div class="col-sm-12 menu">
        <mat-form-field appearance="fill" [hidden]="!regionList || regionList.length == 0" style="width: 12%">
          <mat-label>Region</mat-label>
          <mat-select [(value)]="selectedRegionId" (selectionChange)="regionChange($event.value)">
            <mat-option>None</mat-option>
            @for (region of regionList; track region) {
              <mat-option [value]="region.id">{{region.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 26%">
          <mat-label>Depot</mat-label>
          <mat-select [(value)]="selectedDepotId" (selectionChange)="depotChange($event.value)" (openedChange)="dropdownChanged($event)" multiple>
            @for (depot of depotList; track depot) {
              <mat-option [value]="depot.id">{{depot.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 26%">
          <mat-label>Location</mat-label>
          <mat-select [(value)]="selectedLocationId" (selectionChange)="locationChange($event.value)">
            <mat-option>None</mat-option>
            @for (location of locationList; track location) {
              <mat-option [value]="location.id">{{location.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 12%">
          <mat-label>From date</mat-label>
          <input matInput [formControl]="selectedFromDate" [matDatepicker]="fromPicker" (dateChange)="fromDateFilterChanged($event.value)">
          <mat-datepicker-toggle matSuffix [for]="fromPicker">
          </mat-datepicker-toggle>
          <mat-datepicker #fromPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 12%">
          <mat-label>To date</mat-label>
          <input matInput [formControl]="selectedToDate" [matDatepicker]="toPicker" (dateChange)="toDateFilterChanged($event.value)">
          <mat-datepicker-toggle matSuffix [for]="toPicker">
          </mat-datepicker-toggle>
          <mat-datepicker #toPicker></mat-datepicker>
        </mat-form-field>
        <input type="checkbox" class="check-box" [value]="selectedShouldBeSingleOperation" [checked]="selectedShouldBeSingleOperation" (change)="operationChanged()" /><mat-label> Single operation</mat-label>
      </div>
      <div class="col-sm-12 results">
        @if (!this.selectedRegionId && !this.selectedDepotId) {
          <div id="message">
            Please select a depot.
          </div>
        }
        <div id="report">
          @if (data?.roros && data.roros.length > 0) {
            <div id="roros">
              <h5>RoRo</h5>
              <table class='table table-striped' aria-labelledby="tableLabel">
                <thead>
                  <tr>
                    <th class="default">
                      Container Group
                    </th>
                    <th class="type" title="The number of containers in depot at the start of the selected period">
                      Start
                    </th>
                    <th class="type" title="The number of containers in depot at the end of the selected period">
                      End
                    </th>
                    <th class="type" title="The maximum number of containers used on any day within the selected period">
                      Max. Used
                    </th>
                    <th class="type" title="The difference between 'End' and 'Max. Used'">
                      {{ ("Surplus @ End") }}
                    </th>
                    <th class="type" title="The percentage that were untippable">
                      Untippable
                    </th>
                    <th class="type" title="The percentage growth of containers at customer locations over the selected period">
                      Growth
                    </th>
                    <th class="type" title="The number of containers required">
                      Required
                    </th>
                    @if (!selectedLocationId) {
                      <th class="type" title="The number of jobs over the selected period">
                        Jobs
                      </th>
                    }
                  </tr>
                </thead>
                <tbody class="dummy">
                  <tr>
                    <td class="h-2" colspan="12"></td>
                  </tr>
                </tbody>
                <tbody>
                  @for (group of data.roros; track group) {
                    <tr>
                      <td class="category">
                        <div class="innerWrapper">
                          <div (click)="toggleRow(group.name + '|' + group.category)" class="controls">@if (group.assetTypes?.length && !expandedCategories.includes(group.name + '|' + group.category)) {
                            <i class="material-icons">add</i>
                            }@if (group.assetTypes?.length && expandedCategories.includes(group.name + '|' + group.category)) {
                            <i class="material-icons">remove</i>
                          }</div>
                          <span class="reference">{{ group.name }}</span>
                        </div>
                      </td>
                      <td class="column">
                        <div class="innerWrapper">
                          <span class="default">{{ group.startAssetCount }}</span>
                        </div>
                      </td>
                      <td class="column">
                        <div class="innerWrapper">
                          <span class="default">{{ group.endAssetCount }}</span>
                        </div>
                      </td>
                      <td class="column">
                        <div class="innerWrapper">
                          <span>{{ group.usedCount }}</span>
                        </div>
                      </td>
                      <td class="column">
                        <div class="innerWrapper">
                          <span class="default">{{ group.surplusCount }}</span>
                        </div>
                      </td>
                      <td class="column">
                        <div class="innerWrapper">
                          <span class="default">{{ group.operationalDisturbancePercentageDisplay }}</span>
                        </div>
                      </td>
                      <td class="column">
                        <div class="innerWrapper">
                          <span class="default">{{ group.growthPercentageDisplay }}</span>
                        </div>
                      </td>
                      <td class="column">
                        <div class="innerWrapper">
                          <span>{{ group.required }}</span>
                        </div>
                      </td>
                      @if (!selectedLocationId) {
                        <td class="column">
                          <div class="innerWrapper">
                            <span class="default">{{ group.allJobCount }}</span>
                          </div>
                        </td>
                      }
                    </tr>
                    @if (expandedCategories.includes(group.name + '|' + group.category)) {
                      <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>@if (!selectedLocationId) {
                      <td></td>
                    }</tr>
                    @for (assetType of group.assetTypes; track assetType) {
                      <tr>
                        <td class="default">
                          <div class="innerWrapper">
                            <span class="reference">{{ assetType.name }}</span>
                          </div>
                        </td>
                        <td class="default">
                          <div class="innerWrapper">
                            <span class="default">{{ assetType.startAssetCount }}</span>
                          </div>
                        </td>
                        <td class="default">
                          <div class="innerWrapper">
                            <span class="default">{{ assetType.endAssetCount }}</span>
                          </div>
                        </td>
                        <td class="default">
                          <div class="innerWrapper">
                            <span>{{ assetType.usedCount }}</span>
                          </div>
                        </td>
                        <td class="default">
                          <div class="innerWrapper">
                            <span class="default">{{ assetType.surplusCount }}</span>
                          </div>
                        </td>
                        <td class="default">
                          <div class="innerWrapper">
                            <span class="default">{{ assetType.operationalDisturbancePercentageDisplay }}</span>
                          </div>
                        </td>
                        <td class="default">
                          <div class="innerWrapper">
                            <span class="default">{{ assetType.growthPercentageDisplay }}</span>
                          </div>
                        </td>
                        <td class="default">
                          <div class="innerWrapper">
                            <span>{{ assetType.required }}</span>
                          </div>
                        </td>
                        @if (!selectedLocationId) {
                          <td class="default">
                            <div class="innerWrapper">
                              <span class="default">{{ assetType.allJobCount }}</span>
                            </div>
                          </td>
                        }
                      </tr>
                    }
                    <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>@if (!selectedLocationId) {
                    <td></td>
                  }</tr>
                }
              }
            </tbody>
          </table>
        </div>
      }
      @if (data?.skips && data.skips.length > 0) {
        <div id="skips">
          <h5>Skip</h5>
          <table class='table table-striped' aria-labelledby="tableLabel">
            <thead>
              <tr>
                <th class="default">
                  Container Group
                </th>
                <th class="type" title="The number of containers in depot at the start of the selected period">
                  Start
                </th>
                <th class="type" title="The number of containers in depot at the end of the selected period">
                  End
                </th>
                <th class="type" title="The maximum number of containers used on any day within the selected period">
                  Max. Used
                </th>
                <th class="type" title="The difference between 'End' and 'Max. Used'">
                  {{ ("Surplus @ End") }}
                </th>
                <th class="type" title="The percentage that were untippable">
                  Untippable
                </th>
                <th class="type" title="The percentage growth of containers at customer locations over the selected period">
                  Growth
                </th>
                <th class="type" title="The number of containers required">
                  Required
                </th>
                @if (!selectedLocationId) {
                  <th class="type" title="The number of jobs over the selected period">
                    Jobs
                  </th>
                }
              </tr>
            </thead>
            <tbody class="dummy">
              <tr>
                <td class="h-2" colspan="12"></td>
              </tr>
            </tbody>
            <tbody>
              @for (group of data.skips; track group) {
                <tr>
                  <td class="category">
                    <div class="innerWrapper">
                      <div (click)="toggleRow(group.name + '|' + group.category)" class="controls">@if (group.assetTypes?.length && !expandedCategories.includes(group.name + '|' + group.category)) {
                        <i class="material-icons">add</i>
                        }@if (group.assetTypes?.length && expandedCategories.includes(group.name + '|' + group.category)) {
                        <i class="material-icons">remove</i>
                      }</div>
                      <span class="reference">{{ group.name }}</span>
                    </div>
                  </td>
                  <td class="column">
                    <div class="innerWrapper">
                      <span class="default">{{ group.startAssetCount }}</span>
                    </div>
                  </td>
                  <td class="column">
                    <div class="innerWrapper">
                      <span class="default">{{ group.endAssetCount }}</span>
                    </div>
                  </td>
                  <td class="column">
                    <div class="innerWrapper">
                      <span>{{ group.usedCount }}</span>
                    </div>
                  </td>
                  <td class="column">
                    <div class="innerWrapper">
                      <span class="default">{{ group.surplusCount }}</span>
                    </div>
                  </td>
                  <td class="column">
                    <div class="innerWrapper">
                      <span class="default">{{ group.operationalDisturbancePercentageDisplay }}</span>
                    </div>
                  </td>
                  <td class="column">
                    <div class="innerWrapper">
                      <span class="default">{{ group.growthPercentageDisplay }}</span>
                    </div>
                  </td>
                  <td class="column">
                    <div class="innerWrapper">
                      <span>{{ group.required }}</span>
                    </div>
                  </td>
                  @if (!selectedLocationId) {
                    <td class="column">
                      <div class="innerWrapper">
                        <span class="default">{{ group.allJobCount }}</span>
                      </div>
                    </td>
                  }
                </tr>
                @if (expandedCategories.includes(group.name + '|' + group.category)) {
                  <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>@if (!selectedLocationId) {
                  <td></td>
                }</tr>
                @for (assetType of group.assetTypes; track assetType) {
                  <tr>
                    <td class="default">
                      <div class="innerWrapper">
                        <span class="reference">{{ assetType.name }}</span>
                      </div>
                    </td>
                    <td class="default">
                      <div class="innerWrapper">
                        <span class="default">{{ assetType.startAssetCount }}</span>
                      </div>
                    </td>
                    <td class="default">
                      <div class="innerWrapper">
                        <span class="default">{{ assetType.endAssetCount }}</span>
                      </div>
                    </td>
                    <td class="default">
                      <div class="innerWrapper">
                        <span>{{ assetType.usedCount }}</span>
                      </div>
                    </td>
                    <td class="default">
                      <div class="innerWrapper">
                        <span class="default">{{ assetType.surplusCount }}</span>
                      </div>
                    </td>
                    <td class="default">
                      <div class="innerWrapper">
                        <span class="default">{{ assetType.operationalDisturbancePercentageDisplay }}</span>
                      </div>
                    </td>
                    <td class="default">
                      <div class="innerWrapper">
                        <span class="default">{{ assetType.growthPercentageDisplay }}</span>
                      </div>
                    </td>
                    <td class="default">
                      <div class="innerWrapper">
                        <span>{{ assetType.required }}</span>
                      </div>
                    </td>
                    @if (!selectedLocationId) {
                      <td class="default">
                        <div class="innerWrapper">
                          <span class="default">{{ assetType.allJobCount }}</span>
                        </div>
                      </td>
                    }
                  </tr>
                }
                <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>@if (!selectedLocationId) {
                <td></td>
              }</tr>
            }
          }
        </tbody>
      </table>
    </div>
  }
  @if (data?.others && data.others.length > 0) {
    <div id="others">
      <h5>Ungrouped</h5>
      <table class='table table-striped' aria-labelledby="tableLabel">
        <thead>
          <tr>
            <th class="default">
              Container Group
            </th>
            <th class="type" title="The number of containers in depot at the start of the selected period">
              Start
            </th>
            <th class="type" title="The number of containers in depot at the end of the selected period">
              End
            </th>
            <th class="type" title="The maximum number of containers used on any day within the selected period">
              Max. Used
            </th>
            <th class="type" title="The difference between 'End' and 'Max. Used'">
              {{ ("Surplus @ End") }}
            </th>
            <th class="type" title="The percentage that were untippable">
              Untippable
            </th>
            <th class="type" title="The percentage growth of containers at customer locations over the selected period">
              Growth
            </th>
            <th class="type" title="The number of containers required">
              Required
            </th>
            @if (!selectedLocationId) {
              <th class="type" title="The number of jobs over the selected period">
                Jobs
              </th>
            }
          </tr>
        </thead>
        <tbody class="dummy">
          <tr>
            <td class="h-2" colspan="12"></td>
          </tr>
        </tbody>
        <tbody>
          @for (group of data.others; track group) {
            <tr>
              <td class="category">
                <div class="innerWrapper">
                  <span class="reference">{{ group.name }}</span>
                </div>
              </td>
              <td class="column">
                <div class="innerWrapper">
                  <span class="default">{{ group.startAssetCount }}</span>
                </div>
              </td>
              <td class="column">
                <div class="innerWrapper">
                  <span class="default">{{ group.endAssetCount }}</span>
                </div>
              </td>
              <td class="column">
                <div class="innerWrapper">
                  <span>{{ group.usedCount }}</span>
                </div>
              </td>
              <td class="column">
                <div class="innerWrapper">
                  <span class="default">{{ group.surplusCount }}</span>
                </div>
              </td>
              <td class="column">
                <div class="innerWrapper">
                  <span class="default">{{ group.operationalDisturbancePercentageDisplay }}</span>
                </div>
              </td>
              <td class="column">
                <div class="innerWrapper">
                  <span class="default">{{ group.growthPercentageDisplay }}</span>
                </div>
              </td>
              <td class="column">
                <div class="innerWrapper">
                  <span>{{ group.required }}</span>
                </div>
              </td>
              @if (!selectedLocationId) {
                <td class="column">
                  <div class="innerWrapper">
                    <span class="default">{{ group.allJobCount }}</span>
                  </div>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
  @if ((data?.roros && data.roros.length > 0) || (data?.skips && data.skips.length > 0) || (data?.others && data.others.length > 0)) {
    <div id="totals">
      <table class='table table-striped' aria-labelledby="tableLabel">
        <thead>
          <tr>
            <th class="default">All Containers</th>
            <th class="type"></th>
            <th class="type"></th>
            <th class="type"></th>
            <th class="type"></th>
            <th class="type"></th>
            <th class="type"></th>
            <th class="type"></th>
            @if (!selectedLocationId) {
              <th class="type"></th>
            }
          </tr>
        </thead>
        <tbody class="dummy">
          <tr>
            <td class="h-2" colspan="12"></td>
          </tr>
        </tbody>
        <tbody>
          <tr>
            <td class="category">
              <div class="innerWrapper">
                <span class="reference">Total</span>
              </div>
            </td>
            <td class="column">
              <div class="innerWrapper">
                <span class="default">{{ data.startAssetTotal }}</span>
              </div>
            </td>
            <td class="column">
              <div class="innerWrapper">
                <span class="default">{{ data.endAssetTotal }}</span>
              </div>
            </td>
            <td class="column">
              <div class="innerWrapper">
                <span>{{ data.usedTotal }}</span>
              </div>
            </td>
            <td class="column">
              <div class="innerWrapper">
                <span class="default">{{ data.surplusTotal }}</span>
              </div>
            </td>
            <td class="column">
              <div class="innerWrapper">
                <span class="default">{{ data.operationalDisturbancePercentageDisplay }}</span>
              </div>
            </td>
            <td class="column">
              <div class="innerWrapper">
                <span class="default">{{ data.growthPercentageDisplay }}</span>
              </div>
            </td>
            <td class="column">
              <div class="innerWrapper">
                <span>{{ data.required }}</span>
              </div>
            </td>
            @if (!selectedLocationId) {
              <td class="column">
                <div class="innerWrapper">
                  <span class="default">{{ data.allJobTotal }}</span>
                </div>
              </td>
            }
          </tr>
        </tbody>
      </table>
    </div>
  }
</div>
</div>
</div>
</div>
</div>